import { render, staticRenderFns } from "./myprize.vue?vue&type=template&id=f176029c&scoped=true"
import script from "./myprize.js?vue&type=script&lang=js&external"
export * from "./myprize.js?vue&type=script&lang=js&external"
import style0 from "./myprize.css?vue&type=style&index=0&id=f176029c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f176029c",
  null
  
)

export default component.exports